/**
 * Type-safe search param hook for install flow steps.
 *
 * Extracts the correct variant from the InstallFlowSearch discriminated union
 * based on the provided step ID, eliminating the need for non-null assertions.
 *
 * @example
 * ```ts
 * const search = useStepSearch('sensor')
 * // search.locationId is typed as `number`, not `number | undefined`
 * ```
 */

import { useSearch } from '@tanstack/react-router'
import type { InstallFlowSearch } from '@/routes/_authenticated/organization/$organizationId/install-flow'
import type { StepId } from './installFlowConfig'

/**
 * Generic hook that returns strongly-typed search params for a specific step.
 */
export function useStepSearch<T extends StepId>(
  step: T
): Extract<InstallFlowSearch, { step: T }> {
  // Type assertion to narrow the discriminated union based on step
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return useSearch({ strict: false }) as any as Extract<InstallFlowSearch, { step: T }>
}